import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { PartialFlowStep } from "../steps";

// A terminal dropped onto an edge into a "Survey complete" node replaces
// it — the new node takes the edge, and the end step would otherwise be
// left behind as an orphan. Returns the id of the end step to remove.
// Kept separate from drop-element so it stays loadable in unit tests
// (drop-element's import graph pulls in React component chains).
export function replacedHsaEndStepId(
  steps: readonly PartialFlowStep[],
  newNodeType: StepType,
  idTo: string | undefined,
): string | undefined {
  if (
    !idTo ||
    (newNodeType !== StepType.HSA_KNOCKOUT && newNodeType !== StepType.HSA_END)
  ) {
    return undefined;
  }
  const target = steps.find((step) => step.id === idTo);
  return target?.type === StepType.HSA_END ? idTo : undefined;
}
